import React from "react";
import "./RefundPolicy.css";
function RefundPolicy() {
  return (
    <>
      <div>
        <div className="mt-3 mb-3 container main-policy">
          <div>
            <div>
              <h3 className="text-center">Refund & Return Policy</h3>
            </div>
            <hr />

            <div>
              <h4>Refunds (if applicable)</h4>
              <span>
                <p>REFUND POLICY:</p>
              </span>
              <p>
                Once we receive your item, we will inspect it and notify you on the status of your refund. If approved, we will initiate a refund to your credit card (or original method of payment). You will receive the credit within a certain amount of days, depending on your card issuer's policies
              </p>
              <p>
                Specify that items must be in original packaging and unused
              </p>
              <span>
                <p>RETURNS POLICY:</p>
              </span>
              <p>
                We offer a pick-up facility for locations which are serviceable by our logistics partners. Our logistics partner will pick up the return package in 2 - 5 business days from the date the request was placed.
              </p>
              <p>
                We are committed to ensuring a 100% Purchase Protection to customers by offering them genuine products, robust & secure payment gateways and easy returns for items purchased on Voomka.in
              </p>
            </div>

            <div>
              <h4>Sale items (if applicable)</h4>
              <p>
                Only regular priced items may be refunded, unfortunately sale
                items cannot be refunded.
              </p>
            </div>

            <div>
              <h4>Shipping</h4>
              <p>
                We understand that timely and reliable shipping is essential for
                your shopping experience. Once you place an order, our team will
                process it within 3-4 business days. You will receive a
                confirmation email with tracking information once your order is
                shipped.
              </p>
              <p>
                If you still have issues with shipping, please email us at
                support@voomka.in or call customer care , we would be more than happy to help!
              </p>
              <p>
                To return your product, you should mail your product to address given in contact us page.
              </p>
              <p>
                You will be responsible for paying for your own shipping costs
                for returning your item. Shipping costs are non-refundable. If
                you receive a refund, the cost of return shipping will be
                deducted from your refund.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RefundPolicy;
